// custom CSS styles
import "@/styles/global.css";
import '@emarketer/componentlibrary/build/index.css'; // !IMPORTANT for ComponentLibrary after migration from "Styled Components" to "CSS Modules"


/**
 * Scroll to top when route updates.
 * 
 * We can also access the previous/new routes, if this ever needs to be tweaked
 * to only work on certain routes.
 */
export const onPreRouteUpdate = (): void => {
  window.scrollTo(0, 0);
};